import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import MonroeLipPiercingImage from '../../Assets/Piercing Services/monroe lip piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function MonroeLipPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Monroe Lip Piercing UAE | 200 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Monroe Lip Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Monroe Lip Piercing 200 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={MonroeLipPiercingImage} alt="Monroe Lip Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Monroe Lip Piercing</h3>

          <p>
            Add a touch of timeless elegance to your look with our professional Monroe lip piercing services in the UAE, available at an affordable price of 200 AED. Monroe lip piercing is a chic and stylish facial piercing placed above the upper lip on one side, designed to resemble the iconic beauty mark of Marilyn Monroe. This classic and feminine piercing is perfect for individuals who want a subtle yet sophisticated enhancement that highlights their facial features. Typically adorned with a sleek stud, the Monroe piercing creates a refined and glamorous appearance that suits both modern and vintage-inspired styles.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each Monroe lip piercing with precision and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Facial piercings require expert attention due to the sensitivity of the area, and our experienced specialists use advanced techniques to reduce discomfort and complete the procedure quickly and efficiently.
          </p>

          <p>
            Monroe lip piercing is ideal for those who want a stylish and understated look that enhances their natural beauty. Its placement above the upper lip adds a unique focal point to your face, making it both subtle and eye-catching at the same time. This piercing pairs beautifully with other facial piercings such as Medusa, nose, or lower lip piercings, allowing you to create a personalized and balanced aesthetic. Our specialists take the time to understand your preferences and guide you in selecting the best placement and jewelry options to suit your face shape and desired style.
          </p>

          <p>
            The procedure is typically completed within minutes, making it convenient for clients with busy schedules. We provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a comfortable healing process. Our goal is to deliver a safe, stylish, and comfortable experience from start to finish.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that facial piercings can feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is a crucial part of maintaining your Monroe lip piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, oral hygiene practices, and precautions to avoid infection or irritation. Following proper aftercare ensures faster healing and helps maintain the health and appearance of your piercing.
          </p>

          <p>
            Our Monroe lip piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted Monroe lip piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a chic and elegant look effortlessly. Book your Monroe lip piercing appointment today and enhance your style with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Monroe Lip Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default MonroeLipPiercing;